export default __webpack_public_path__ + "static/media/VerificationSuccess.c2a54d76.png";